import I from "axios";
import { useEffect as d, useRef as C, useMemo as O, useCallback as E, useState as a } from "react";
import { a as S } from "./index-B2su9LGZ.mjs";
import { a as b, o as R, b as U, h as x, c as A } from "./fallback-storage-value-DpM7zNd8.mjs";
const q = (e) => ({
  createUser: (r) => I.post(`${e}/email/login`, {
    ...r,
    create: 1,
    flow: 1,
    newsletterSubscribe: 1
  }, {
    headers: {
      "Content-Type": "application/json"
    },
    withCredentials: !0
  })
});
function M(e) {
  const t = b(e);
  d(
    () => () => {
      t.current();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}
function k(e, t, r, i = !1) {
  const n = C(), o = C();
  return M(() => {
    n.current && (clearTimeout(n.current), n.current = void 0);
  }), O(() => {
    const s = (c, l) => {
      o.current = void 0, e.apply(c, l), n.current = setTimeout(() => {
        n.current = void 0, !i && o.current && (s(o.current.this, o.current.args), o.current = void 0);
      }, r);
    }, u = function(...c) {
      if (n.current) {
        o.current = { args: c, this: this };
        return;
      }
      s(this, c);
    };
    return Object.defineProperties(u, {
      length: { value: e.length },
      name: { value: `${e.name || "anonymous"}__throttled__${r}` }
    }), u;
  }, [r, i, ...t]);
}
function j(e = !1) {
  const t = C(e), r = E(() => t.current, []);
  return d(() => (t.current = !0, () => {
    t.current = !1;
  }), []), r;
}
function _(e) {
  d(() => {
    e();
  }, []);
}
const F = [0], z = "0px", g = /* @__PURE__ */ new Map(), D = (e) => {
  const t = e.root ?? document;
  let r = g.get(t);
  r || (r = /* @__PURE__ */ new Map(), g.set(t, r));
  const i = JSON.stringify([e.rootMargin, e.threshold]);
  let n = r.get(i);
  if (!n) {
    const o = /* @__PURE__ */ new Map(), s = new IntersectionObserver((u) => {
      for (const c of u) {
        const l = o.get(c.target);
        if (!(l === void 0 || l.size === 0))
          for (const f of l)
            setTimeout(() => {
              f(c);
            }, 0);
      }
    }, e);
    n = {
      observer: s,
      observe(u, c) {
        let l = o.get(u);
        l || (l = /* @__PURE__ */ new Set(), o.set(u, l), s.observe(u)), l.add(c);
      },
      unobserve(u, c) {
        const l = o.get(u);
        l && (l.delete(c), l.size === 0 && (o.delete(u), s.unobserve(u), o.size === 0 && (s.disconnect(), r.delete(i), r.size === 0 && g.delete(t))));
      }
    }, r.set(i, n);
  }
  return n;
};
function B(e, { threshold: t = F, root: r, rootMargin: i = z } = {}) {
  const [n, o] = a();
  return d(() => {
    const s = e && "current" in e ? e.current : e;
    if (!s)
      return;
    let u = !0;
    const c = D({
      root: r && "current" in r ? r.current : r,
      rootMargin: i,
      threshold: t
    }), l = (f) => {
      u && o(f);
    };
    return c.observe(s, l), () => {
      u = !1, c.unobserve(s, l);
    };
  }, [e, r, i, ...t]), n;
}
function G(e, ...t) {
  const r = j(), i = b(t[1]), n = O(
    () => (
      // As some event listeners designed to be used through `this`
      // it is better to make listener a conventional function as it
      // infers call context
      function(...o) {
        r() && (typeof i.current == "function" ? i.current.apply(this, o) : typeof i.current.handleEvent == "function" && i.current.handleEvent.apply(this, o));
      }
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  d(() => {
    const o = L(e) ? e.current : e;
    if (!o)
      return;
    const s = t.slice(2);
    return R(o, t[0], n, ...s), () => {
      U(o, t[0], n, ...s);
    };
  }, [e, t[0]]);
}
function L(e) {
  return e !== null && typeof e == "object" && x(e, "current");
}
function K() {
  const [e, t] = a();
  return G(S(), "blur", () => {
    var r;
    typeof globalThis > "u" || t((r = document) === null || r === void 0 ? void 0 : r.activeElement);
  }), {
    activeElement: e
  };
}
/*! js-cookie v3.0.5 | MIT */
function h(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var i in r)
      e[i] = r[i];
  }
  return e;
}
var H = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function y(e, t) {
  function r(n, o, s) {
    if (!(typeof document > "u")) {
      s = h({}, t, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var u = "";
      for (var c in s)
        s[c] && (u += "; " + c, s[c] !== !0 && (u += "=" + s[c].split(";")[0]));
      return document.cookie = n + "=" + e.write(o, n) + u;
    }
  }
  function i(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], s = {}, u = 0; u < o.length; u++) {
        var c = o[u].split("="), l = c.slice(1).join("=");
        try {
          var f = decodeURIComponent(c[0]);
          if (s[f] = e.read(l, f), n === f)
            break;
        } catch {
        }
      }
      return n ? s[n] : s;
    }
  }
  return Object.create(
    {
      set: r,
      get: i,
      remove: function(n, o) {
        r(
          n,
          "",
          h({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return y(this.converter, h({}, this.attributes, n));
      },
      withConverter: function(n) {
        return y(h({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var m = y(H, { path: "/" });
const Q = (e, t) => {
  const r = b(t), i = A(), [n, o] = a(() => {
    var c;
    return i && t !== null && t !== void 0 && t.initializeWithValue && (c = m.get(e)) !== null && c !== void 0 ? c : null;
  }), s = E((c) => {
    m.set(e, c, r.current), o(c);
  }, [e, r]), u = E(() => {
    m.remove(e), o(null);
  }, [e]);
  return _(() => {
    const c = m.get(e);
    n || !c || o(c);
  }), [n, s, u];
}, X = (e) => {
  const {
    ga4TrackingHandler: t,
    getGa4Event: r,
    options: i
  } = e, n = b(r), [o, s] = a(null), [u, c] = a(!1), [l, f] = a(void 0), v = i != null && i.shouldSendOnce ? !u : !0, T = B(v && n.current ? o : null, {
    threshold: i == null ? void 0 : i.intersectionThreshold
  });
  d(() => {
    f(T);
  }, [T]);
  const w = k((p) => {
    i != null && i.isSendGA4Tracking && p && t && t(p), c(!0);
  }, [t, c], i != null && i.shouldThrottle ? 300 : 0, !0);
  return d(() => {
    !v || !(l != null && l.isIntersecting) || !n.current || w(n.current ? n.current() : null);
  }, [v, l == null ? void 0 : l.isIntersecting, w, n]), d(() => {
    f(void 0), c(!1);
  }, [o]), {
    captureTrackImpressionEventTargetElement: E((p) => {
      s(p);
    }, [s]),
    intersection: l
  };
};
export {
  K as a,
  Q as b,
  X as c,
  _ as d,
  B as e,
  q as u
};
//# sourceMappingURL=tracking-impression-event-ZV5D7zg4.mjs.map
